import { DIRECTIVE_NAME } from "./GapImage"
import ModalState from "reusable/mobx-helpers/ModalState"
import { apiClient } from "api/trpc/trpc-client"
import { makeAutoObservable } from "mobx"
import MarkdownStore from "reusable/markdown/MarkdownStore"
import { decodeFile } from "reusable/utils/file-operations"

interface GapImagePluginStoreProps {
   insertDirective: (directive: any) => void
   markdownStore: MarkdownStore
}

export default class GapImagePluginStore {
   sp
   modalState = new ModalState({
      onClose: async () => {
         this.file = null
         this.uploadedFileName = null
      }
   })
   file: File | null = null
   private uploadedFileName: string | null = null

   constructor(sp: GapImagePluginStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   getPresignedUrl = async (file: File) => {
      this.uploadedFileName = file.name
      const { url } = await apiClient.markdown.getFileUploadUrl.query({ fileName: this.uploadedFileName, entityId: this.sp.markdownStore.sp.id })
      return url
   }

   onFilesValidated = async (files: File[]) => {
      if (files.length === 0 || !this.uploadedFileName) return
      const { file } = decodeFile(this.uploadedFileName)
      const name = file.name

      const dimensions = await this.getImageDimensions(files[0])

      this.sp.insertDirective({
         name: DIRECTIVE_NAME,
         type: 'leafDirective',
         attributes: {
            name, // Name as uploaded
            rawFileName: this.uploadedFileName, // Includes ulid in filename
            width: dimensions.width.toString(),
            height: dimensions.height.toString(),
         },
      })

      this.file = files[0]

      this.uploadedFileName = null
      this.modalState.close()
   }

   private getImageDimensions = (file: File): Promise<{ width: number; height: number }> => {
      return new Promise((resolve, reject) => {
         const img = new Image()
         const objectUrl = URL.createObjectURL(file)

         img.onload = () => {
            URL.revokeObjectURL(objectUrl) 
            resolve({
               width: img.naturalWidth,
               height: img.naturalHeight,
            })
         }

         img.onerror = () => {
            URL.revokeObjectURL(objectUrl)
            reject(new Error('Failed to load image'))
         }

         img.src = objectUrl
      })
   }
}
